import * as Yup from "yup"


export class UpdateMicrojobForm {
    address?: string | null = ""
    phone?: string | null = ""
    email?: string | null = ""

    public static fromServerResponse(response: any): UpdateMicrojobForm {
        const form = new UpdateMicrojobForm()
        form.address = response.address
        form.phone = response.phone
        form.email = response.email

        return form
    }
}


const MicrojobCardValidation = {
    selected: Yup.string().max(256).required(),
}

export default Yup.object()
    .shape(
        MicrojobCardValidation,
    )
    .required()
